import { defineStore } from "pinia";
import { ref } from "vue";

export const useGlobalStore = defineStore('global', () => {
	const galleryImages = ref(null);

	const selectedApartment = ref(null);

	return {
		galleryImages,
		selectedApartment,
	};
});